import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';

import { env } from '~/commons/config';

import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormArticle from '../../forms/FormArticle.jsx';

const PageArticle = () => {
  const { _id } = useParams();
  const [res, req] = useHttpStatus();

  useEffect(() => {
    if (_id !== 'new') {
      req({
        url: `api/quiz/articles/${_id}`,
      });
    }
  }, [_id]);

  const breadcrumb = [
    { to: '../', children: 'Articles' },
  ];

  return (
    <>
      {_id === 'new' ? (
        <div>
          <Header breadcrumb={breadcrumb}>Create New</Header>
          <FormArticle />
        </div>
      ) : (
        <PageHttp res={res}>
          {(doc) => (
            <>
              <Header breadcrumb={breadcrumb}>Editor</Header>
              <FormArticle article={doc} />
            </>
          )}
        </PageHttp>
      )}
    </>
  );
};

export default PageArticle;
